import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { initPageLoader } from "./loader.js";
import { initLoadMoreArticles } from "./loadmore-articles.js";
import { initLoadMoreRelatedArticles } from "./loadmore-related-articles.js";
import { initNavigation } from "./navigation.js";
import { initSmoothScroll } from "./smooth-scroll.js";
import { initTruckAnimation } from "./truck-animation.js";

gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function ($) {
  AOS.init({
    duration: 800,
    once: true,
    offset: 100,
  });

  initNavigation();
  initLoadMoreArticles();
  initLoadMoreRelatedArticles();
  initTruckAnimation();
  initPageLoader();
  initSmoothScroll();

  $(window).on("load", function () {
    // Recalculate all Start/End positions
    ScrollTrigger.refresh();
  });

  document.documentElement.classList.add("js-enabled");
});
